export class Setup {
    title: string;
    subTitle: string;
    aboutTitle: string;
    aboutSubTitle: string;
    address: string;
    email: string;
    phone: string;
    projectTitle: string;
    projectSubTitle: string;
    valueTitle: string;
    valueSubTitle: string;
    createdDate: Date;
    createdUserId: string;
    lastUpdatedUserId: string;
    lastUpdatedDate: Date;
}
